import {createSlice} from "@reduxjs/toolkit";

const initialState = {
    data: [],
    loading: false,
    error: {},
    totalItems: 0
};
const statsDesc = createSlice({
    name: 'statsDesc',
    initialState,
    reducers: {
        setStatsDescData: (state, action) => {
            state.totalItems = action.payload.length;
            state.data = action.payload;
            return state;
        },
        setStatsDescLoading: (state, action) => {
            state.loading = action.payload;
            return state;
        },
        setStatsDescError: (state, action) => {
            state.error = action.payload;
            return state;
        }
    }
});
export const {setStatsDescData, setStatsDescLoading, setStatsDescError} = statsDesc.actions;
export default statsDesc.reducer;